import React, { useEffect, useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { StepIndicator } from '../components/StepIndicator';
import { CheckCircleIcon, ImageIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Master Creative', 'Campaign Setup', 'Select Creative', 'Styling Template', 'Variable Content', 'Generate', 'Review & Publish'];
export function GenerateCreatives() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [currentStep, setCurrentStep] = useState('Initializing...');
  useEffect(() => {
    const steps = [{
      label: 'Loading dealer data...',
      duration: 1000
    }, {
      label: 'Applying pricing and offers...',
      duration: 1500
    }, {
      label: 'Generating dealer-specific creatives...',
      duration: 3000
    }, {
      label: 'Finalizing...',
      duration: 1000
    }];
    let currentProgress = 0;
    let stepIndex = 0;
    const interval = setInterval(() => {
      if (stepIndex < steps.length) {
        setCurrentStep(steps[stepIndex].label);
        const increment = 100 / steps.length;
        currentProgress += increment;
        setProgress(Math.min(currentProgress, 100));
        stepIndex++;
      } else {
        clearInterval(interval);
        setIsComplete(true);
      }
    }, 1500);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2097">
      <Sidebar data-id="element-2098" />
      <main className="flex-1" data-id="element-2099">
        <Header data-id="element-2100" />
        <StepIndicator currentStep={6} steps={STEPS} data-id="element-2101" />
        <div className="px-6 py-8" data-id="element-2102">
          <div className="max-w-4xl mx-auto" data-id="element-2103">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2104">
              Step 5: Generate Creatives
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-2105">
              Auto-generating dealer-specific creatives with your configurations
            </p>

            {!isComplete ? <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-2106">
                <div className="text-center mb-8" data-id="element-2107">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2108">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" data-id="element-2109"></div>
                  </div>
                  <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2110">
                    {currentStep}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-2111">
                    This may take a few minutes...
                  </p>
                </div>

                <div className="mb-4" data-id="element-2112">
                  <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-2113">
                    <span data-id="element-2114">Progress</span>
                    <span data-id="element-2115">{Math.round(progress)}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3" data-id="element-2116">
                    <div className="bg-blue-500 h-3 rounded-full transition-all duration-500" style={{
                  width: `${progress}%`
                }} data-id="element-2117"></div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-6" data-id="element-2118">
                  <h4 className="font-medium text-blue-900 mb-2" data-id="element-2119">
                    What's Happening?
                  </h4>
                  <ul className="text-sm text-blue-800 space-y-1" data-id="element-2120">
                    <li data-id="element-2121">• Auto-filling dealer names, phones, and addresses</li>
                    <li data-id="element-2122">• Applying state-wise pricing configurations</li>
                    <li data-id="element-2123">• Adding offer and festival text</li>
                    <li data-id="element-2124">• Generating unique creatives for each dealer</li>
                  </ul>
                </div>
              </div> : <div className="space-y-6" data-id="element-2125">
                <div className="bg-green-50 border border-green-200 rounded-lg p-6" data-id="element-2126">
                  <div className="flex items-center mb-4" data-id="element-2127">
                    <CheckCircleIcon className="text-green-500 mr-3" size={32} data-id="element-2128" />
                    <div data-id="element-2129">
                      <h3 className="text-lg font-medium text-green-900" data-id="element-2130">
                        Generation Complete!
                      </h3>
                      <p className="text-sm text-green-700" data-id="element-2131">
                        500 dealer-specific creatives generated successfully
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2132">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-2133">
                    Preview Gallery
                  </h3>
                  <div className="grid grid-cols-4 gap-4" data-id="element-2134">
                    {[...Array(8)].map((_, i) => <div key={i} className="border border-gray-200 rounded-lg p-3" data-id="element-2135">
                        <div className="w-full h-32 bg-gray-100 rounded-lg mb-2 flex items-center justify-center" data-id="element-2136">
                          <ImageIcon className="text-gray-400" size={32} data-id="element-2137" />
                        </div>
                        <p className="text-xs font-medium text-gray-700" data-id="element-2138">
                          Dealer {i + 1}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-2139">Mumbai</p>
                      </div>)}
                  </div>
                  <p className="text-sm text-gray-500 text-center mt-4" data-id="element-2140">
                    Showing 8 of 500 creatives
                  </p>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2141">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-2142">
                    Generation Summary
                  </h3>
                  <div className="grid grid-cols-3 gap-4" data-id="element-2143">
                    <div className="bg-gray-50 rounded-lg p-4" data-id="element-2144">
                      <p className="text-2xl font-semibold text-gray-800" data-id="element-2145">
                        500
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-2146">
                        Creatives Generated
                      </p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4" data-id="element-2147">
                      <p className="text-2xl font-semibold text-gray-800" data-id="element-2148">8</p>
                      <p className="text-sm text-gray-600" data-id="element-2149">Dealers Covered</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4" data-id="element-2150">
                      <p className="text-2xl font-semibold text-gray-800" data-id="element-2151">
                        3 formats
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-2152">Per Dealer</p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-between" data-id="element-2153">
                  <button onClick={() => navigate('/dealerization/step-4')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-2154">
                    Back
                  </button>
                  <button onClick={() => navigate('/dealerization/step-6')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600" data-id="element-2155">
                    Continue to Review & Publish
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}